import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function GlimpsesPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/glimpses").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  const photos = items.filter((item) => item.type === "photo");
  const testimonials = items.filter((item) => item.type === "testimonial");

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="text-center max-w-3xl mx-auto mb-14">
        <div className="text-xs uppercase tracking-widest text-accent mb-3">Glimpses of OITS</div>
        <h1 className="heading-serif text-5xl sm:text-6xl">Moments, memories & stories.</h1>
        <p className="mt-5 text-muted-foreground leading-relaxed">
          A collection of moments from journeys with OITS, along with stories shared by our travellers.
        </p>
      </div>

      <section>
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs uppercase tracking-widest text-accent mb-2">Gallery</div>
            <h2 className="heading-serif text-4xl">Glimpses from our journeys</h2>
          </div>
        </div>
        {photos.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {photos.map((item) => (
              <div key={item.id} className="rounded-xl overflow-hidden border border-border bg-card">
                <img src={`${process.env.REACT_APP_BACKEND_URL}${item.image_url}`} alt={item.title || "OITS travel moment"} className="w-full aspect-[4/3] object-cover" />
                {item.title && <div className="p-4 text-sm font-medium">{item.title}</div>}
              </div>
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-border rounded-xl p-10 text-center text-muted-foreground">
            OITS travel photos will appear here soon.
          </div>
        )}
      </section>

      <section className="mt-24">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-widest text-accent mb-2">Testimonials</div>
          <h2 className="heading-serif text-4xl">What our travellers say</h2>
        </div>
        {testimonials.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((item) => (
              <div key={item.id} className="border border-border rounded-xl p-6 bg-card">
                <p className="text-muted-foreground leading-relaxed">“{item.testimonial}”</p>
                <div className="mt-6">
                  <div className="font-medium">{item.name}</div>
                  {item.destination && <div className="text-xs text-muted-foreground mt-1">{item.destination}</div>}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-border rounded-xl p-10 text-center text-muted-foreground">
            Traveller testimonials will appear here soon.
          </div>
        )}
      </section>
    </div>
  );
}
